import { SessionLogStatus } from '../../../hooks/analytics/useAnalytics';
import { SessionDetailDto } from '@repo/shared/dtos/analytics/SessionDataDto';
import { SessionLogTable } from './SessionLogTable';
import { ArrowLeft } from 'lucide-react';

interface SessionLogPanelProps {
  data: SessionDetailDto[] | undefined;
  isLoading: boolean;
  error: Error | null;
  onRetry: () => void;
  status: SessionLogStatus;
  onBack?: () => void;
}

export function SessionLogPanel({
  data,
  isLoading,
  error,
  onRetry,
  status,
  onBack,
}: SessionLogPanelProps) {
  if (!status.hasDateRange) {
    return (
      <div className="mt-4 rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-6 text-sm text-[var(--anl-text-muted)]">
        Select a date range to view the session log.
      </div>
    );
  }

  if (status.rangeExceedsLimit) {
    return (
      <div className="mt-4 space-y-3 rounded-lg border border-[var(--anl-border)] bg-[var(--anl-surface-elev)] p-6 text-sm text-[var(--anl-text-muted)]">
        <p>
          The selected date range spans {status.monthCount} months, which exceeds the{' '}
          {status.maxMonths}-month limit for session logs.
        </p>
        <p>Adjust the range to {status.maxMonths} months or fewer to view detailed sessions.</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {onBack && (
        <div className="flex items-center justify-between">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-sm font-medium text-[var(--anl-text)] transition-colors hover:text-[var(--anl-text)]"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Chart
          </button>
        </div>
      )}
      <SessionLogTable
        items={data ?? []}
        isLoading={isLoading}
        error={error}
        onRetry={onRetry}
        className="mb-1"
      />
    </div>
  );
}
